import { PacketType } from "../enum/PacketType";
import Transform from "../lib/Transform";
import Vector2 from "../math/Vector2";
import Serializer from "./Serializer";



export default class Packet extends Serializer {

    static Read(data: Uint8Array) {
        const pkt = new Serializer(Array.from(data));
        const type: PacketType = pkt.readBytes(1)[0];
        const packet = new Packet(type);
        packet.writeBytes(...pkt.buffer);

        return packet;
    }

    constructor(type: PacketType) {
        super([type]);
    }

    readType(): PacketType {
        return this.readBytes(1)[0];
    }

    writeVector2(vector: Vector2) {
        this.writeFloat32(vector.x);
        this.writeFloat32(vector.y);
    }

    readVector2() {
        const x = this.readFloat32();
        const y = this.readFloat32();

        return new Vector2(x, y);
    }

    writeTransform(transform: Transform) {
        this.writeVector2(transform.position);
        this.writeVector2(transform.rotation);
        this.writeVector2(transform.scale);
    }

    readTransform() {
        const position = this.readVector2();
        const rotation = this.readVector2();
        const scale = this.readVector2();

        return {
            position,
            rotation,
            scale
        }
    }

}